import React from 'react';
import './Sidebar.css';


function Sidebar() {
    return (
        <div className="sidebar__main">
            <div className="sidebar">
                <ul>
                    <li>Heloo</li>
                    <li>Heloo</li>
                    <li>Heloo</li>
                    <li>Heloo</li>
                </ul>
            </div>
        </div>

    )
}

export default Sidebar
